import copy from 'copy-to-clipboard';
import clsx from 'clsx';
import { ReactNode } from 'react';
import { getDataIdGenerator } from '../../shared/utils/dataId';
import { Button } from '../Button';
import { toasterService } from '../../toaster/toaster.service';

export interface CopyToClipboardButtonProps {
  copyText: string;
  toastMessage: string;
  dataId: string;
  className?: string;
  size?: 'md' | 'sm';
  withoutBorder?: boolean;
  iconOnly?: boolean;
  children?: ReactNode;
  disabled?: boolean;
}

export function CopyToClipboardButton({
  copyText,
  toastMessage,
  dataId,
  className,
  size = 'sm',
  withoutBorder,
  iconOnly = true,
  children,
  disabled
}: CopyToClipboardButtonProps) {
  const dataIdGenerator = getDataIdGenerator(dataId, 'copy');

  return (
    <Button
      dataId={dataIdGenerator('')}
      className={clsx(className)}
      onClick={() => {
        copy(copyText);
        toasterService.pop('success', undefined, toastMessage);
      }}
      icon='copy'
      iconOnly={iconOnly}
      size={size}
      disabled={disabled}
      variation={withoutBorder ? 'flat' : 'outline'}
    >
      {children}
    </Button>
  );
}
